module.exports = __webpack_public_path__ + "img/9788971849767.ac998161.jpg";